import { LOGIN, LOGOUT, UPDATE_PROFILE } from '../actions.type';
import initialState from '../initialState';

export default function(state = initialState.user, action) {
  switch (action.type) {
    case LOGIN:
      return action.user;
    case LOGOUT:
      return initialState.user;
    case UPDATE_PROFILE:
      return { ...state, profile: action.profile };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/user/user.reducer.js